import { ClbCheckbox } from '@celebration/react/ClbCheckbox/ClbCheckbox';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Dropdown, {
    DropdownTrigger,
    DropdownItems,
} from '../../../../common/components/dropdown';
import ICarrierCardProps from './interfaces/ICarrierCardProps';
import ICarrierInfo from '../../../branches/interfaces/ICarrierInfo';
import BranchesConstants from '../../../branches/constants';
import Icon from '../../../../common/components/icon';
import Text from '../../../../common/components/text';
import { ReactComponent as HomeIcon } from '../../../../common/assets/svg/home.svg';
import Auth from '../../../../app/contexts/auth';
import { SULAHUB_ROLES } from '../../../../common/constants/roles';

function CarrierCard({
    carrier,
    handleCarrierCheckboxCallback,
    deleteCarrierCallback,
    editCarrierCallback,
}: Readonly<ICarrierCardProps>) {
    const { isAuthorized } = Auth.useAuth();
    const { t } = useTranslation();

    const renderDeleteCarrier = () => {
        return (
            isAuthorized([
                SULAHUB_ROLES.SYSTEM_PROFILES.SULA_USER,
                SULAHUB_ROLES.SYSTEM_PROFILES.MESA_PLUS_ADMIN,
                SULAHUB_ROLES.SYSTEM_PROFILES.TP_ADMIN_USER,
            ]) && (
                <Dropdown>
                    <DropdownTrigger>
                        <Icon
                            className="icon-button"
                            icon="more"
                            data-testid="carrier-card-more-icon"
                        />
                    </DropdownTrigger>

                    <DropdownItems>
                        <button
                            type="button"
                            onClick={() => deleteCarrierCallback(carrier.id)}
                            data-testid="card-carrier-dropdown-delete"
                        >
                            {t('TransportadoraApagar')}
                        </button>

                        <button
                            type="button"
                            onClick={() => editCarrierCallback(carrier.id)}
                            data-testid="card-carrier-dropdown-edit"
                        >
                            {t('TransportadoraEditar')}
                        </button>
                    </DropdownItems>
                </Dropdown>
            )
        );
    };

    return (
        <div className="card-carrier" data-testid="carrier-card">
            <div className="card-carrier-content">
                <div className="checkbox-column">
                    <ClbCheckbox
                        onChange={(event: any) =>
                            handleCarrierCheckboxCallback(carrier.id, event)
                        }
                        checked={carrier.checked}
                        data-testid="card-carrier-checkbox"
                    >
                        <></>
                    </ClbCheckbox>
                </div>

                <div className="trade-name-column">
                    <Link
                        to={BranchesConstants.PATH}
                        state={
                            {
                                carrierId: carrier.id,
                                carrierName: carrier.tradeName,
                            } as ICarrierInfo
                        }
                    >
                        <Text
                            className="carrier-trade-name"
                            value={carrier.tradeName}
                        />
                        <Text className="carrier-name" value={carrier.name} />
                        <Text
                            className="carrier-branches"
                            svgIcon={<HomeIcon className="branches-icon" />}
                            value={`${carrier.branchesCount} ${t('filiais')}`}
                        />
                    </Link>
                </div>

                <div className="image-column">
                    {carrier.logoUrl ? (
                        <img
                            className="carrier-logo"
                            src={carrier.logoUrl}
                            alt="carrier-logo"
                        />
                    ) : (
                        <div className="no-logo-carrier" />
                    )}
                </div>

                <div className="more-column">{renderDeleteCarrier()}</div>
            </div>
        </div>
    );
}

export default CarrierCard;
